import { useMutation } from '@tanstack/react-query';
import {
  type GoodsOption,
  type GoodsOptionsPricingResponse,
  orderService,
} from 'shared/src/api';
import { useIsBottomSheetGiftMode } from '../hooks/useIsBottomSheetGiftMode';

export const useProductCheckout = (selected: GoodsOption[]) => {
  const isGiftMode = useIsBottomSheetGiftMode();
  return useMutation({
    throwOnError: false,
    mutationFn: async ({
      pricing,
      redeemedCouponSnos,
    }: {
      pricing: GoodsOptionsPricingResponse;
      redeemedCouponSnos: number[];
    }) => {
      const couponSnos = Array.from(
        new Set([
          ...pricing.coupon_list
            .filter(item => item.item.is_issued)
            .map(coupon => coupon.item.sno),
          ...redeemedCouponSnos,
        ]),
      );

      return orderService.postProductCheckout({
        order_type: isGiftMode ? 1 : 0,
        from_ablypay_benefit: false,
        coupon_snos: couponSnos,
        goods_options: selected.map(option => ({
          delivery_type: option.delivery_type,
          sno: option.sno,
          text_option: option.message ?? null,
          ea: option.purchase_count ?? 1,
        })),
      });
    },
  });
};
